import React from 'react';
import AoLovesMobileWrapper from './MobileViewWrapper/AoLovesMobileWrapper';
import Wrapper from './MobileViewWrapper/Wrapper';
import EnhancedWrapper from '../ProductCardListView/ListViewWrapper/Wrapper';

const ProductCardMobileView = ({ index, product }) => {
	const showFeaturedProduct = index === 0 && product.IsFeaturedProduct;

	if (product.ShouldShowEnhancedCard) {
		return <EnhancedWrapper {...{ product, index }} />;
	}

	return showFeaturedProduct ? (
		<AoLovesMobileWrapper {...{ product, index }} />
	) : (
		<Wrapper {...{ product, index }} />
	);
};

export default ProductCardMobileView;
